import React from 'react';
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";

import SelectionWindow from "./selectionWindow";
import MaterialsWizard from "../qkbPages/materialsWizard/materialsWizard";
import {showWizardInsteadOfQT} from "../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";

class SelectionWindowPage extends React.Component {

  componentDidUpdate() {
    if (this.props.fabricatorSettings.showTutorialVideo && window.location.href.includes("materials")
      && !this.props.introVideo.introVideoFinished) {
      this.props.history.push("/tutorial-intro/1");
    }
  }

  render() {
    const {wizardList, wizardIsActive, visualizersLoaded} = this.props;
    if (!visualizersLoaded.length) {
      return null
    }
    if (showWizardInsteadOfQT(wizardList, wizardIsActive)) {
      return <MaterialsWizard/>
    }
    return <SelectionWindow params={this.props.params}/>;
  }
}

const mapStateToProps = (store) => {
  const {wizardList, wizardIsActive} = store.wizardState;
  const {settings} = store.fabricatorState;
  const {visualizersLoaded, introVideo} = store.serverState;


  return {
    visualizersLoaded,
    introVideo,
    fabricatorSettings: settings,
    wizardList,
    wizardIsActive,
  };
};

export default withRouter(
  connect(mapStateToProps)(SelectionWindowPage)
);
